module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/home-sale.svg?9d747adc743333aff21dde3b2a629225";